import { render, staticRenderFns } from "./LangPairsSection.vue?vue&type=template&id=ec725610&scoped=true&"
import script from "./LangPairsSection.vue?vue&type=script&lang=js&"
export * from "./LangPairsSection.vue?vue&type=script&lang=js&"
import style0 from "./LangPairsSection.vue?vue&type=style&index=0&id=ec725610&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec725610",
  null
  
)

export default component.exports